import { SvgIconToggleColor, ToggleColorType } from '../types/domain/svg-icons';

const getSVGIconToggleColor = (
  type: ToggleColorType,
  toggle: boolean,
  toggleColorCombination: SvgIconToggleColor = {
    highlighted: '#0A4842',
    background: '#FFFFFF',
  }
) => {
  if (toggle) {
    if (type === ToggleColorType.background) {
      return toggleColorCombination.background;
    }
    return toggleColorCombination.highlighted;
  } else {
    if (type === ToggleColorType.background) {
      return toggleColorCombination.highlighted;
    }
    return toggleColorCombination.background;
  }
};

export default getSVGIconToggleColor;
